module.exports = window.dnn.nodeModules.ReactRedux;